import InternalNotificationCard from '@shared/components/core/alertNotification/InternalNotificationCard';
import { useTranslation } from 'react-i18next';

/**
 * Shown in place of the invite controls when the organization provisions members over SCIM. The API
 * refuses portal invites for these organizations, so the notice explains where membership is actually
 * managed rather than leaving people with a button that always fails.
 */
export default function InviteScimManagedNotice() {
    const { t } = useTranslation('common');

    return (
        <InternalNotificationCard
            color="info"
            icon="orgCompany"
            title={t('organization.invite.scimManaged.title')}
            subtitle={t('organization.invite.scimManaged.description')}
        />
    );
}
